import { useEffect, useRef } from "react";

/**
 * Runs `effect` after `delay` ms of quiet.
 *
 * The Site Builder autosaves the draft on every keystroke; without this it
 * would PATCH once per character.
 */
export function useDebouncedEffect(effect: () => void, delay: number, deps: unknown[]): void {
  const callback = useRef(effect);
  callback.current = effect;

  useEffect(() => {
    const timer = window.setTimeout(() => callback.current(), delay);
    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delay, ...deps]);
}
